/**
 * Number of consecutive auth failures a poller tolerates before it stops.
 * A small allowance rides out the brief window where a token has expired but the
 * silent renewal has not completed yet, without letting a genuinely signed-out
 * tab keep hitting the API forever.
 */
export const MAX_CONSECUTIVE_AUTH_FAILURES = 3;

/** Treats 401/403 responses as auth failures (both our UnauthorisedResponse and real server rejections). */
export const isAuthFailure = (response: { statusCode?: number }): boolean =>
  response.statusCode === 401 || response.statusCode === 403;

/**
 * Tracks consecutive auth failures for a polling loop. Feed each response to
 * `record`; it returns `true` once the breaker has tripped, at which point the
 * caller should stop polling. Any non-auth-failure response resets the count.
 */
export const createAuthFailureCircuitBreaker = (max: number = MAX_CONSECUTIVE_AUTH_FAILURES) => {
  let consecutiveFailures = 0;

  return {
    record: (response: { statusCode?: number }): boolean => {
      if (isAuthFailure(response)) {
        consecutiveFailures += 1;
      } else {
        consecutiveFailures = 0;
      }
      return consecutiveFailures >= max;
    }
  };
};
